//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
// import './FormNivel1.css';
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import sistemaContext from '../../context/sistemaContex/sistemaContext';
import activoContext from '../../context/activoContex/activoContex';



const FormSistema = ({data, minimizar, handleChangeSistema, addOrEditForm}) => {

    const {actualizaractivoList} = useContext(activoContext)
    
    const sContext = useContext(sistemaContext);
    const {actualizarSistema, agregarSistema, modificarSistema, eliminarSistema} = sContext;

    const [system, setSystem] = useState((!addOrEditForm) ? {codSistema: data.codSistema, name: data.value} : {codSistema: '', name: ''});
    
    const titulo = (addOrEditForm) ? 'Agregar' : 'Modificar';

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};
        if (system.codSistema === '' || system.codSistema === undefined) return newErrors.codigo = 'El código debe ser colocado'
        if (system.name === ''|| system.codSistema === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';  
    };

    const handlerGenerar = async ()  => {
 
        const errorAxi = validacion();
        
        if ( errorAxi === "" ) {

            try {
                const res = await agregarSistema(system);
    
                if (res !== undefined) {
                    Swal.fire({
                        title: `Se guardo un nuevo Sistema`,
                        icon: 'success',
                        text: `Código: ${res.codSistema} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    setSystem(system.group)
                    actualizarSistema();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el nombre o el código de Sistema",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {
        
        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: data._id,
                    name: system.name,
                    codSistema: system.codSistema
                }

                const res = await modificarSistema(dato);
                let newSistem = {
                    codSistema:res.codSistema, label:res.name, value:res.name, name: res.name, _id:res._id
                }
                handleChangeSistema(newSistem);
                
                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó el Sistema`,
                        icon: 'success',
                        text: `Código: ${res.codSistema} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarSistema();
                    actualizaractivoList();
                    minimizar({...dato, label: res.name, value:res.name});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el nombre o código del Sistema",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
 
    }

    const handlerEliminar = () => {

        Swal.fire({
            title: `Estas seguro que deseas eliminar este Sistema?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data._id
                const resp = await eliminarSistema(id);

                if(resp === "No se puede borrar sistema porque contiene componentes" ||
                resp === "No se puede borrar sistema porque contiene subsistema"
                ) {
                    Swal.fire({
                        title: `No se puede borra el sistema`,
                        icon: 'warning',
                        text: `Para poder eliminar el sistema no tiene que tener componenetes o substemas`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    minimizar(null);
                }else {
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El sistema fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizaractivoList();
                    actualizarSistema();
                    minimizar(null);
                    handleChangeSistema({codSistema:'',name:''});
                }
                
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
            });
    }

    const handleChange = (e) => {
        setSystem({...system,[e.target.name]:e.target.value});
    }

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Sistema
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Código: </div>
                <input name='codSistema' disabled={!addOrEditForm} value={system.codSistema} className='label-form-group-data' 
                onChange={data => handleChange(data)} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input name='name' value={system.name}className='label-form-group-data'
                    onChange={data => handleChange(data)}/>
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={(addOrEditForm) ? handlerGenerar : handlerModificar}>{titulo}</button> 
                {(!addOrEditForm) && <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>}
                <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
            </div>
        </div>
    )
}

export default FormSistema;